import { useEffect, useState } from "react";
import * as configUtils from "util/config";

export const useComexDocs = () => {
    const [comexDocs, setComexDocs] = useState({});

    useEffect(() => {
        setComexDocs({
            codeFile1: configUtils.get("comex.thuban.code.file1"),
            codeFile2: configUtils.get("comex.thuban.code.file2"),
            codeFile3: configUtils.get("comex.thuban.code.file3"),
            codeFile4: configUtils.get("comex.thuban.code.file4"),
            codeFile5: configUtils.get("comex.thuban.code.file5"),
            codeFile6: configUtils.get("comex.thuban.code.file6"),
            codeFile7: configUtils.get("comex.thuban.code.file7"),
            codeFile8: configUtils.get("comex.thuban.code.file8"),
            codeFile9: configUtils.get("comex.thuban.code.file9"),
            codeFile10: configUtils.get("comex.thuban.code.file10"),
            codeFile11: configUtils.get("comex.thuban.code.file11"),
            codeFile12: configUtils.get("comex.thuban.code.file12"),
            codeFile13: configUtils.get("comex.thuban.code.file13"),
            codeStatute: configUtils.get("comex.thuban.code.statute"),
            codeOfferLetter: configUtils.get("comex.thuban.code.offerLetterAndAcceptance"),
            codeInvoice: configUtils.get("comex.thuban.code.invoice"),
            codeCertificate6401: configUtils.get("comex.thuban.code.certificate6401"),
            codeAccountingCertification: configUtils.get("comex.thuban.code.accountingCertification"),
            codeServiceCertification: configUtils.get("comex.thuban.code.serviceCertification"),
            codeDDJJ: configUtils.get("comex.thuban.code.ddjj"),
        });
    }, []);

    return comexDocs;
};

export default useComexDocs;
